import Service from '@ember/service';

import { once } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import window from 'ember-window-mock';

import ENV from 'rise-ui/config/environment.js';
import config from 'rise-ui/config/config.js';
import { join } from 'rise-ui/utils/string.js';

const { maxUrlLength } = config;

export default class UrlRegisterService extends Service {
  @service ssr;

  @tracked hasLongUrls = false;

  rootUrl;

  constructor() {
    super(...arguments);

    const {
      host = this.ssr.request.host,
      protocol = this.ssr.request.protocol,
    } = window.location || {};
    this.rootUrl = join([ `${protocol}//${host}`, ENV.rootURL ], '/');
  }

  register(ctx, url) {
    const { _longUrls } = this;
    _longUrls.delete(ctx);
    if (!this._isProtectedUrl(url)) {
      return;
    }
    url = this._routeUrl(url);
    if (!url) {
      return;
    }
    if (url.length > maxUrlLength) {
      _longUrls.set(ctx, url);
    }
    once(this, '_updateLongUrls');
  }

  @service('notifications') _notifications;

  _longUrls = new Map();
  _notification;

  _isProtectedUrl(url) {
    return url && (url.charAt(0) === '/' || url.startsWith(this.rootUrl));
  }

  _routeUrl(url) {
    return !url ? url : url.charAt(0) === '/' ? join([ this.rootUrl, url ], '/') : url;
  }

  _updateLongUrls() {
    if (this.hasLongUrls) {
      if (!this._longUrls.size) {
        this.hasLongUrls = false;
        this._notifications.removeNotification(this._notification);
      }
    } else {
      if (this._longUrls.size) {
        this.hasLongUrls = true;
        this._notification = this._notifications.warning(
          'Further selections may result in a page error.'
        );
      }
    }
    if (this.hasLongUrls) {
      const urls = [];
      this._longUrls.forEach(url => urls.push(url));
      console.error(
        `${urls.length} URLs fail max length (${maxUrlLength}): \n`
        + urls.map(url => `  (${url.length}): ${url}`).join('\n'),
      );
    }
  }
}
